export const selectFilter = (state) => state.filter.filter;
export const selectIsLoading = (state) => state.filter.isLoading;
